import {useMutation, useQueryClient} from '@tanstack/react-query'
import {MUTATION_KEYS, QUERY_KEYS} from './keys'
import {GUEST_API} from '../services/guest.http'

export const useSaveHost = (onSuccess?: () => void) => {
    const queryClient = useQueryClient()
    const query = useMutation({
        mutationKey: [MUTATION_KEYS.save_host],
        mutationFn: (hostId: number) => GUEST_API.saveHost({hostId}),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: [QUERY_KEYS.saved_hosts]})
            onSuccess?.()
        }
    })
    return {...query, isPending: query.isPending || queryClient.isFetching({queryKey: [QUERY_KEYS.saved_hosts]}) > 0}
}
